import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { RobotEngineModel } from './../../../foundations-webct-robot/robot/robotEngineModel';
import { Utils } from './../../../foundations-webct-robot/robot/utils/utils.service';
import { JsonParams } from './../../../foundations-webct-robot/robot/classes/jsonParams.class';

// import { ModalService } from 'foundations-webct-palette/components/modalComponent/modal.service';
import { ModalService} from './../../../foundations-webct-robot/robot/services/modal.service';
import { FilterService } from './../../../foundations-webct-robot/robot/services/filter.service';

@Component({
  selector: 'app-wct-header',
  templateUrl: './wct-header.component.html',
  styleUrls: ['./wct-header.component.css']
})
export class WctHeaderComponent implements OnInit {

  @Input() public viewStructure: JsonParams;
  @Input() public dataRecs;
  @Input() public inputParameters: JsonParams[];
  @Input() public sideFilterId: string;

  @Output() public reloadEmit = new EventEmitter();

  public refreshMe = false;
  public allowReload = false;

  constructor(
    private _utils: Utils,
    private _filter: FilterService,
    private _modalService: ModalService,
    private _robot: RobotEngineModel,
    private _router: Router) {
  }

  ngOnInit(): void {

    let reloadConfig = this._utils.findObjectInArray(this.viewStructure.parameters, 'reload');
    this.allowReload = reloadConfig.value || false;
  }

  public reloadComponent() {
    this.refreshMe = true;
    this.reloadEmit.next(true);
  }

  public toggleFilter = () => this._filter.toggleFilterStatus(this.sideFilterId)

}
